<template>
    <div class="view-qualify-step-work-environment qualify-sidebar">
        <h2 class="sidebar-title">
            {{ $t('commitment_and_work_environment') }}
        </h2>

        <!--<qualify-sidebar-input-container :label="$t('environment')" :is-mandatory="true">-->
        <qualify-sidebar-input-container :label="$t('environment')">
            <qualify-sidebar-input-item :is-filled="!!environment">
                <b-select v-model="environment" class="medium-input" size="is-large" expanded rounded>
                    <option
                        v-for="option in environmentOptions"
                        :key="option.code"
                        :value="option.code"
                    >
                        {{ option.label }}
                    </option>
                </b-select>
            </qualify-sidebar-input-item>
        </qualify-sidebar-input-container>

<!--       retiré-->
        <transition name="fade">
            <qualify-sidebar-input-container :label="$t('inside_floor_type')" v-if="isInside">
                <qualify-sidebar-input-item :is-filled="!!insideFloorType">
                    <b-select v-model="insideFloorType" class="medium-input" size="is-large" expanded rounded>
                        <option
                            v-for="option in insideFloorTypeOptions"
                            :key="option.code"
                            :value="option.code"
                        >
                            {{ option.label }}
                        </option>
                    </b-select>
                </qualify-sidebar-input-item>
            </qualify-sidebar-input-container>
        </transition>

        <transition name="fade">
            <qualify-sidebar-input-container :label="$t('outside_floor_type')" v-if="isOutside">
                <qualify-sidebar-input-item :is-filled="!!outsideFloorType">
                    <b-select v-model="outsideFloorType" class="medium-input" size="is-large" expanded rounded>
                        <option
                            v-for="option in outsideFloorTypeOptions"
                            :key="option.code"
                            :value="option.code"
                        >
                            {{ option.label }}
                        </option>
                    </b-select>
                </qualify-sidebar-input-item>
            </qualify-sidebar-input-container>
        </transition>

<!--        <qualify-sidebar-input-container :label="$t('floor_surface_type')">
            <qualify-sidebar-input-item :is-filled="!!floorSurfaceType">
                <b-select v-model="floorSurfaceType" class="medium-input" size="is-large" expanded rounded>
                    <option
                        v-for="option in floorSurfaceTypeOptions"
                        :key="option.code"
                        :value="option.code"
                    >
                        {{ option.label }}
                    </option>
                </b-select>
            </qualify-sidebar-input-item>
        </qualify-sidebar-input-container>

        <qualify-sidebar-input-container :label="$t('usage_hours_per_day')">
            <qualify-sidebar-input-item :suffix="'h'" :is-filled="usageHoursPerDay.length > 0">
                <b-input
                    v-model="usageHoursPerDay"
                    size="is-large"
                    class="small-input"
                    autocomplete="new-password"
                    rounded
                />
            </qualify-sidebar-input-item>
        </qualify-sidebar-input-container>

        <qualify-sidebar-input-container :label="$t('workstation_number')">
            <qualify-sidebar-input-item :is-filled="!!workstationNumber">
                <b-select v-model="workstationNumber" class="medium-input" size="is-large" expanded rounded>
                    <option
                        v-for="option in workstationNumberOptions"
                        :key="option.code"
                        :value="option.code"
                    >
                        {{ option.label }}
                    </option>
                </b-select>
            </qualify-sidebar-input-item>
        </qualify-sidebar-input-container>

        <qualify-sidebar-input-container :label="$t('speed_limit')">
            <qualify-sidebar-input-item :is-vertical="true" :is-filled="speedLimitExist !== null">
                <div class="vertical-input-item">
                    <b-radio v-model="speedLimitExist" type="is-brand" class="" size="is-medium" :native-value="true">
                        {{ $t('yes') }}
                    </b-radio>
                </div>
                <div class="vertical-input-item">
                    <b-radio v-model="speedLimitExist" type="is-brand" size="is-medium" :native-value="false">
                        {{ $t('no') }}
                    </b-radio>
                </div>
            </qualify-sidebar-input-item>
        </qualify-sidebar-input-container>

        <transition name="fade">
            <qualify-sidebar-input-container :label="$t('speed_limited_at')" v-if="speedLimitExist">
                <qualify-sidebar-input-item :suffix="'km/h'" :is-filled="!!speedLimit">
                    <b-select v-model="speedLimit" class="medium-input" size="is-large" expanded rounded>
                        <option
                            v-for="option in speedLimitOptions"
                            :key="option.code"
                            :value="option.code"
                        >
                            {{ option.label }}
                        </option>
                    </b-select>
                </qualify-sidebar-input-item>
            </qualify-sidebar-input-container>
        </transition>

        <qualify-sidebar-input-container :label="$t('work_conditions')">
            <qualify-sidebar-input-item :is-vertical="true" :is-filled="workConditions.length > 0">
                <div
                    class="vertical-input-item"
                    v-for="option in workConditionsOptions"
                    :key="option.code"
                >
                    <b-checkbox
                        v-model="workConditions"
                        type="is-brand"
                        size="is-medium"
                        :native-value="option.code"
                    >
                        {{ option.label }}
                    </b-checkbox>
                </div>
            </qualify-sidebar-input-item>
        </qualify-sidebar-input-container>

        <qualify-sidebar-input-container :label="$t('load_time_available')">
            <qualify-sidebar-input-item :suffix="'min'" :is-filled="loadTimeAvailable.length > 0">
                <b-input
                    v-model="loadTimeAvailable"
                    size="is-large"
                    class="small-input"
                    autocomplete="new-password"
                    rounded
                />
            </qualify-sidebar-input-item>
        </qualify-sidebar-input-container>

        <qualify-sidebar-input-container :label="$t('load_type')">
            <qualify-sidebar-input-item :is-vertical="true" :is-filled="loadType !== null">
                <div class="vertical-input-item">
                    <b-radio v-model="loadType" type="is-brand" size="is-medium" :native-value="true">
                        {{ $t('single_phase') }}
                    </b-radio>
                </div>
                <div class="vertical-input-item">
                    <b-radio v-model="loadType" type="is-brand" size="is-medium" :native-value="false">
                        {{ $t('three_phase') }}
                    </b-radio>
                </div>
            </qualify-sidebar-input-item>
        </qualify-sidebar-input-container>

        <qualify-sidebar-input-container :label="$t('load_room')">
            <qualify-sidebar-input-item :is-vertical="true" :is-filled="loadRoom !== null">
                <div class="vertical-input-item">
                    <b-radio v-model="loadRoom" type="is-brand" size="is-medium" :native-value="true">
                        {{ $t('yes') }}
                    </b-radio>
                </div>
                <div class="vertical-input-item">
                    <b-radio v-model="loadRoom" type="is-brand" size="is-medium" :native-value="false">
                        {{ $t('no') }}
                    </b-radio>
                </div>
            </qualify-sidebar-input-item>
        </qualify-sidebar-input-container>

        <qualify-sidebar-input-container :label="$t('maintenance_contract')">
            <qualify-sidebar-input-item :is-vertical="true" :is-filled="maintenanceContract !== null">
                <div class="vertical-input-item">
                    <b-radio v-model="maintenanceContract" type="is-brand" size="is-medium" :native-value="true">
                        {{ $t('yes') }}
                    </b-radio>
                </div>
                <div class="vertical-input-item">
                    <b-radio v-model="maintenanceContract" type="is-brand" size="is-medium" :native-value="false">
                        {{ $t('no') }}
                    </b-radio>
                </div>
            </qualify-sidebar-input-item>
        </qualify-sidebar-input-container>

        <qualify-sidebar-input-container :label="$t('provider')">
            <qualify-sidebar-input-item :is-vertical="true" :is-filled="provider !== null">
                <div class="vertical-input-item">
                    <b-radio v-model="provider" type="is-brand" size="is-medium" :native-value="true">
                        {{ $t('yes') }}
                    </b-radio>
                </div>
                <div class="vertical-input-item">
                    <b-radio v-model="provider" type="is-brand" size="is-medium" :native-value="false">
                        {{ $t('no') }}
                    </b-radio>
                </div>
            </qualify-sidebar-input-item>
        </qualify-sidebar-input-container>-->
    </div>
</template>

<script>
    import QualifySidebarInputContainer from "@/components/QualifySidebarInput/QualifySidebarInputContainer.vue"
    import QualifySidebarInputItem from "@/components/QualifySidebarInput/QualifySidebarInputItem.vue"
    import {mapState} from "vuex";
    import _ from "lodash";

    export default {
        name: 'QualifyIndustryWorkEnvironment',
        components:{
            QualifySidebarInputContainer,
            QualifySidebarInputItem
        },
        data(){
            return {
                environmentOptions: [
                    {
                        code: null,
                        label: '-'
                    },
                    {
                        code: 'outside',
                        label: this.$t('outside')
                    },
                    {
                        code: 'inside',
                        label: this.$t('inside')
                    },
                    {
                        code: 'outside_and_inside',
                        label: this.$t('outside_and_inside')
                    },
                ],
                insideFloorTypeOptions: [
                    {
                        code: null,
                        label: '-'
                    },
                    {
                        code: 'asphalted',
                        label: this.$t('asphalted')
                    },
                    {
                        code: 'paved',
                        label: this.$t('paved')
                    },
                    {
                        code: 'concreted',
                        label: this.$t('concreted')
                    },
                    {
                        code: 'unstabilized',
                        label: this.$t('unstabilized')
                    },
                ],
                outsideFloorTypeOptions: [
                    {
                        code: null,
                        label: '-'
                    },
                    {
                        code: 'asphalted',
                        label: this.$t('asphalted')
                    },
                    {
                        code: 'paved',
                        label: this.$t('paved')
                    },
                    {
                        code: 'concreted',
                        label: this.$t('concreted')
                    },
                    {
                        code: 'unstabilized',
                        label: this.$t('unstabilized')
                    },
                    {
                        code: 'asphalted_and_unstabilized',
                        label: this.$t('asphalted_and_unstabilized')
                    },
                ],
                floorSurfaceTypeOptions: [
                    {
                        code: null,
                        label: '-'
                    },
                    {
                        code: 'abrasive',
                        label: this.$t('abrasive')
                    },
                    {
                        code: 'bright',
                        label: this.$t('bright')
                    },
                    {
                        code: 'smooth',
                        label: this.$t('smooth')
                    },
                ],
                workstationNumberOptions: [
                    {
                        code: null,
                        label: '-'
                    },
                    {
                        code: '1_8',
                        label: '1/8'
                    },
                    {
                        code: '2_8',
                        label: '2/8'
                    },
                    {
                        code: '3_8',
                        label: '3/8'
                    },
                    {
                        code: '4_8',
                        label: '4/8'
                    },
                    {
                        code: '5_8',
                        label: '5/8'
                    },
                ],
                speedLimitOptions: [{ code: null, label: '-' }].concat([...Array(40).keys()].map(x => ({ code: x+1, label: x+1 }))),
                workConditionsOptions: [
                    {
                        code: 'dusty',
                        label: this.$t('dusty')
                    },
                    {
                        code: 'slippery',
                        label: this.$t('slippery')
                    },
                    {
                        code: 'wet',
                        label: this.$t('wet')
                    },
                    {
                        code: 'intermittent_refrigeration',
                        label: this.$t('intermittent_refrigeration')
                    },
                    {
                        code: 'permanent_refrigeration',
                        label: this.$t('permanent_refrigeration')
                    },
                    {
                        code: 'sensitive',
                        label: this.$t('sensitive')
                    },
                    {
                        code: 'positive_cold',
                        label: this.$t('positive_cold')
                    },
                    {
                        code: 'corrosive',
                        label: this.$t('corrosive')
                    },
                    {
                        code: 'atex_zone_1',
                        label: this.$t('atex_zone_1')
                    },
                    {
                        code: 'atex_zone_2',
                        label: this.$t('atex_zone_2')
                    },
                ],
            }
        },
        computed: {
            ...mapState({
                environments: state => state.qualifyIndustry.environments,
            }),
            environment: {
                get () { return this.$store.state.qualifyIndustry.environment },
                set (value) {
                  this.$store.commit('qualifyIndustry/setEnvironment', value);
                  this.updateSteps();
                }
            },
            insideFloorType: {
                get () { return this.$store.state.qualifyIndustry.insideFloorType },
                set (value) { this.$store.commit('qualifyIndustry/setInsideFloorType', value) }
            },
            outsideFloorType: {
                get () { return this.$store.state.qualifyIndustry.outsideFloorType },
                set (value) { this.$store.commit('qualifyIndustry/setOutsideFloorType', value) }
            },
            floorSurfaceType: {
                get () { return this.$store.state.qualifyIndustry.floorSurfaceType },
                set (value) { this.$store.commit('qualifyIndustry/setFloorSurfaceType', value) }
            },
            usageHoursPerDay: {
                get () { return this.$store.state.qualifyIndustry.usageHoursPerDay },
                set (value) { this.$store.commit('qualifyIndustry/setUsageHoursPerDay', value) }
            },
            workstationNumber: {
                get () { return this.$store.state.qualifyIndustry.workstationNumber },
                set (value) { this.$store.commit('qualifyIndustry/setWorkstationNumber', value) }
            },
            speedLimitExist: {
                get () { return this.$store.state.qualifyIndustry.speedLimitExist },
                set (value) { this.$store.commit('qualifyIndustry/setSpeedLimitExist', value) }
            },
            speedLimit: {
                get () { return this.$store.state.qualifyIndustry.speedLimit },
                set (value) { this.$store.commit('qualifyIndustry/setSpeedLimit', value) }
            },
            workConditions: {
                get () { return this.$store.state.qualifyIndustry.workConditions },
                set (value) { this.$store.commit('qualifyIndustry/setWorkConditions', value) }
            },
            loadTimeAvailable: {
                get () { return this.$store.state.qualifyIndustry.loadTimeAvailable },
                set (value) { this.$store.commit('qualifyIndustry/setLoadTimeAvailable', value) }
            },
            loadType: {
                get () { return this.$store.state.qualifyIndustry.loadType },
                set (value) { this.$store.commit('qualifyIndustry/setLoadType', value) }
            },
            loadRoom: {
                get () { return this.$store.state.qualifyIndustry.loadRoom },
                set (value) { this.$store.commit('qualifyIndustry/setLoadRoom', value) }
            },
            maintenanceContract: {
                get () { return this.$store.state.qualifyIndustry.maintenanceContract },
                set (value) { this.$store.commit('qualifyIndustry/setMaintenanceContract', value) }
            },
            provider: {
                get () { return this.$store.state.qualifyIndustry.provider },
                set (value) { this.$store.commit('qualifyIndustry/setProvider', value) }
            },
            isInside(){
                return (this.environment === 'inside' || this.environment === 'outside_and_inside');
            },
            isOutside(){
                return (this.environment === 'outside' || this.environment === 'outside_and_inside');
            }
        },
        watch: {
            environment(){
                this.outsideFloorType = null;
                this.insideFloorType = null;
            }
        },
        created(){
            if(!this.$route.query.backward)
                this.$store.commit('qualifyIndustry/resetWorkEnvironment');

            this.$store.commit('qualifyIndustry/setNextStepAllowed', false);
            this.checkNextStepAllowed();

            this.$watch(vm => [
                vm.environment,
            ].join(), () => this.checkNextStepAllowed())
        },
        methods: {
            checkNextStepAllowed(){
                // this.$store.commit('qualifyIndustry/setNextStepAllowed', !!this.environment);
                this.$store.commit('qualifyIndustry/setNextStepAllowed', true);
            },
            updateSteps() {
                let steps = [
                  {
                    code: 'work-environment',
                    contentLayout: 'sidebarAndDynamicPicture',
                    label: this.$t('work_environment')
                  },
                ];

                let currentEnv = this.environments.find(env => env.code === this.environment);
                if (currentEnv && currentEnv.steps && currentEnv.steps.length) {
                    currentEnv.steps.forEach(step => {
                        let newStep = {
                          code: "building-and-shelving",
                          context: step.context,
                          contentLayout: step.contentLayout,
                          label: step.label
                        };

                        steps.push(newStep);
                    });
                }

                steps.push(
                    {
                      code: 'results-machines',
                      contentLayout: 'classicContent',
                      label: this.$t('machines')
                    },
                    {
                      code: 'the-solutions',
                      contentLayout: 'classicContent',
                      label: this.$t('solutions')
                    }
                );

                this.$store.commit('qualifyIndustry/setSteps', steps);

                // this.$store.commit('qualifyIndustry/setCurrentStep', steps[0].code);
            }
        }
    }
</script>

<style lang="scss">
.view-qualify-step-work-environment {

}
</style>
